import * as React from "react";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../stores/seekerStore";
import ProfileStore from "../../stores/profileStore";
import { ExperienceType, JobType, EdType, EmptyId, AddExpRoute } from "../../models/enums";
import { WorkExperience } from "../../models/profile";
import { ILocalization, IOption } from "../../models/localization";
import { Grid, Row, Col } from "react-flexbox-grid";
import BackButton from "../../components/widgets/backBtn";
import { FormControl } from "material-ui/Form";
import { InputLabel } from "material-ui/Input";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import WorkExperienceEditor from "../../components/profile/workExperienceEditor";
import MilitaryExperienceEditor from "../../components/profile/militaryExperienceEditor";
import ActivityExperienceEditor from "../../components/profile/lifeExperienceEditor";
import EducationExperienceEditor from "../../components/profile/educationExperienceEditor";
import CCLCEditor from "../../components/profile/cclcEditor";
import LangEditor from "../../components/profile/langEditor";
import AddEditNavBtns from "../../components/profile/addEditNavBtns";
import * as s from "./experience.css";

@observer
class ExperiencePicker extends React.Component<{ store: SeekerStore, value: ExperienceType, onChange: (type: ExperienceType) => void }, {}> {

  constructor(props: any) {
    super(props);
  }

  componentWillUnmount(): void {
    this.props.store.profileStore.resetAddExpRoute();
  }

  render(): JSX.Element {  
    const local: ILocalization = this.props.store.localization.fields;
    if (!local) {
      return null;
    }
    const menus: JSX.Element[] = [];  
    const route: AddExpRoute = this.props.store.profileStore.addExpRoute;
    if (route === AddExpRoute.All) {
      menus.push(<MenuItem key="no-sel" value={0}>{local.select}</MenuItem>);
      local.expTypes.map((option: IOption, i: number): void => {
        menus.push(<MenuItem key={i} value={option.value}>{option.text}</MenuItem>);
      });
    }
    if (route === AddExpRoute.Experience) {
      menus.push(<MenuItem key="no-sel" value={0}>{local.select}</MenuItem>);
      local.expTypes.map((option: IOption, i: number): void => {
        if (i < 5) {
          menus.push(<MenuItem key={i} value={option.value}>{option.text}</MenuItem>);
        }
      });
    }
    if (this.props.store.profileStore.addExpRoute === AddExpRoute.Lanuage) {
      local.expTypes.map((option: IOption, i: number): void => {
        if (i === 5) {
          menus.push(<MenuItem key={i} value={option.value}>{option.text}</MenuItem>);
        }
      });
    }
    if (route === AddExpRoute.Cclc) {
      local.expTypes.map((option: IOption, i: number): void => {
        if (i === 6) {
          menus.push(<MenuItem key={i} value={option.value}>{option.text}</MenuItem>);
        }
      });
    }
    return <Row>
      <Col xs={12} sm={6} lg={4} xl={3}>
        <FormControl fullWidth>
          <InputLabel htmlFor="expType">{local.addExp}</InputLabel>
          <Select value={this.props.value} onChange={(e: any) => this.props.onChange(e.target.value)} inputProps={{ name: "expType", id: "expType" }}>
            {menus}
          </Select>
        </FormControl>
      </Col>
    </Row>;
  }
}

interface IParams {
    id: string;
    expType?: string;
}
@inject("store") @observer
export default class AddExperienceVw extends React.Component<{ store: SeekerStore, params: IParams}, {}> {
  isEditing: boolean;
  name: string;
  constructor(props: any) {
    super(props);
    this.name = null;
  }
  componentWillMount(): void {
    if (!this.props.store.viewState.requireAuthentication(false)) {
      return;
    }
    window.scrollTo(0, 0);
    this.isEditing = window.location.hash.includes("edit-experience/", 0) && this.props.params !== null && this.props.params.id.length > 0;
    const tokens: string[] = window.location.href.split("?");
    if (tokens.length > 1) {
      const st: string[] = tokens[1].split("=");
      if (st.length === 2 && st[0] === "name") {
        this.name = decodeURIComponent(st[1]);
      }
    }
    this.props.store.profileStore.clearEdits();
    if (this.isEditing) {
      this.props.store.profileStore.setEditExperience(this.props.params.id);
    }
    if (this.props.params.expType && this.props.params.expType != null) {
      this.props.store.profileStore.experienceType = parseInt(this.props.params.expType, 10);
      this.props.store.profileStore.addActivity(parseInt(this.props.params.expType, 10));
    }
  }

  componentWillUpdate() {
    this.isEditing = window.location.hash.includes("edit-experience/", 0) && this.props.params !== null;
  }

  @action setExperienceType = (type: number): void => {
      this.props.store.profileStore.addActivity(type);
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const et: ExperienceType = this.props.store.profileStore.experienceType;
    const ps: ProfileStore = this.props.store.profileStore;
    let showBtns: boolean = et !== ExperienceType.NotSpecified;
    if (et === ExperienceType.Life && (!ps.editActivity || ps.editActivity.typeId === EmptyId)) {
      showBtns = false;
    }

    return (<div>
      <BackButton />  
      <Grid className={s.container}>
        <h4 className={s.blueHeader}>{local.addExp}</h4>
        {!this.isEditing && <Row>
          <Col xs={12}><p className={s.smallText}>{local.opportunity.step1header}</p></Col>
            <Col xs={12}>
              <ExperiencePicker store={this.props.store} value={et} onChange={this.setExperienceType} />
              <br />
            </Col>
        </Row>
        }
      {et === 0 && this.isEditing && <Row> <Col xs={12}><p className={s.smallText}>This page has expired</p></Col></Row>}
      {et !== 0 && <Row> <Col xs={12}><p className={s.smallText}>{local.opportunity.step2header}</p></Col></Row>}
      {et === ExperienceType.Work && ps.editWork && ps.editWork.expType === JobType.Work && <WorkExperienceEditor store={this.props.store} exp={ps.editWork} fromResume={false} />}
      {et === ExperienceType.Military && ps.editWork && ps.editWork.expType === JobType.Military && <MilitaryExperienceEditor store={this.props.store} exp={ps.editWork} fromResume={false} />}
      {et === ExperienceType.GEDDegree && ps.editEducation && ps.editEducation.edType === EdType.DegreeProgram && <EducationExperienceEditor store={this.props.store} exp={ps.editEducation} fromResume={false} />}
      {et === ExperienceType.Course && ps.editEducation && ps.editEducation.edType === EdType.Course && <EducationExperienceEditor store={this.props.store} exp={ps.editEducation} fromResume={false} />}
      {et === ExperienceType.Life && ps.editActivity && <ActivityExperienceEditor store={this.props.store} exp={ps.editActivity} fromResume={false} />}
      {et === ExperienceType.CCLC && ps.editCCLC && <CCLCEditor store={this.props.store} exp={ps.editCCLC} name={this.name} />}
      {et === ExperienceType.Language && <LangEditor store={this.props.store} fromResume={false} />}
      {showBtns && <AddEditNavBtns store={this.props.store} />}
      <br />
      <br />
      </Grid>
      </div>);
  }
}


// WEBPACK FOOTER //
// ./src/views/addExperience/index.tsx